import React, { useState } from "react";
import {
  Button,
  Col,
  Container,
  Input,
  Label,
  Row,
  FormGroup,
  FormFeedback,
} from "reactstrap";
import { Formik, Form, Field, useField } from "formik";
import FileUploadBox from "components/FileUpload/FileUploadBox";
import * as Yup from "yup";
import { PageSubHeader } from "components/CommonLayouts/PageSubHeader";
//import FileUploadBox from "components/FileUpload/FileUploadBox";

// Validation Schema
const validationSchema = Yup.object().shape({
  firstName: Yup.string().required("First Name is required"),
  lastName: Yup.string().required("Last Name is required"),
  mobile: Yup.string()
    .matches(/^[0-9]{10}$/, "Must be a valid 10-digit number")
    .required("Mobile Number is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
  preferredRole: Yup.string().required("Preferred Job Role is required"),
  experience: Yup.string().required("Experience is required"),
  willingToRelocate: Yup.string().required("Relocation preference is required"),

  //   workingStatus: Yup.string().required("Working Status is required"),
  //   noticePeriod: Yup.string().required("Notice Period is required"),
  status: Yup.string().required("Status is required"),
  dob: Yup.string().required("Date of Birth is required"),
  gender: Yup.string().required("Gender is required"),
  country: Yup.string().required("Country is required"),
  address: Yup.string().required("Address is required"),
  linkedIn: Yup.string()
    .url("Must be a valid URL")
    .required("LinkedIn is required"),
  //   github: Yup.string().url("Must be a valid URL").required("Git Hub is required"),

  zipcode: Yup.string()
    .matches(/^[0-9]{6}$/, "Zipcode must be a 6-digit number")
    .required("Zipcode is required"),
  province: Yup.string().required("Province is required"),
  city: Yup.string().required("City is required"),
  //   portfolio: Yup.string().url("Must be a valid URL"),

  // 👇 Conditional validation for experienced candidates
  experienceDetails: Yup.string().when("experience", {
    is: (val) => val === "Experienced",
    then: (schema) => schema.required("Experience Details is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  currentCtc: Yup.string().when("experience", {
    is: (val) => val === "Experienced",
    then: (schema) => schema.required("Current CTC is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  expectedCtc: Yup.string().when("experience", {
    is: (val) => val === "Experienced",
    then: (schema) => schema.required("Expected CTC is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  resume: Yup.mixed()
    .required("Resume is required")
    .test(
      "fileSize",
      "File too large",
      (value) => !value || value.size <= 2 * 1024 * 1024
    ) // 2MB
    .test(
      "fileType",
      "Unsupported file format",
      (value) =>
        !value ||
        [
          "application/pdf",
          "application/msword",
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        ].includes(value.type)
    ),

  // New validation for marital status
  //   maritalStatus: Yup.string().required("Marital Status is required"),
});

// Custom Input Field Wrapper
const FormikInput = ({ label, id, ...props }) => {
  const [field, meta] = useField(props);
  return (
    <FormGroup>
      {label && <Label htmlFor={id}>{label}</Label>}
      <Input
        id={id}
        {...field}
        {...props}
        invalid={meta.touched && !!meta.error}
      />
      <FormFeedback>{meta.error}</FormFeedback>
    </FormGroup>
  );
};

const NewCandidates = () => {
  const [experience, setExperience] = useState("Fresher");

  return (
    <div className="page-content">
      <PageSubHeader
        heading={"Add New Candidate"}
        routePath={"Home"}
        pageName={"Add Candidates"}
      />
      <Container fluid className="py- px-4">
        {/* <Row className="py-3  mt-5">
                    <p className="sub-heading">View Job Postings/ JD1023/ View Post/ Add Candidates</p>
                    <h2 className="heading">Add New Candidate</h2>
                </Row> */}

        <Formik
          initialValues={{
            firstName: "",
            lastName: "",
            mobile: "",
            email: "",
            preferredRole: "",
            experience: "Fresher",
            workingStatus: "",
            noticePeriod: "",
            status: "",
            experienceDetails: "",
            willingToRelocate: "",
            dob: "",
            gender: "",
            maritalStatus: "",
            country: "",
            province: "",
            zipcode: "",
            city: "",
            address: "",
            linkedIn: "",
            github: "",
            portfolio: "",
            currentCtc: "",
            expectedCtc: "",
            resume: null,
          }}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            // console.log("Submitted values:", values);
            // console.log(validationSchema.lastName)
          }}
        >
          {({ handleChange, setFieldValue }) => (
            <Form>
              {/* General Info */}
              <Row className="heading mt-3 pe-4">
                <p className="sub-head">01 - General Information</p>
                {/* <hr className="mb-1"/> */}
              </Row>
              {/* <hr className="mt-0"/> */}
              <Row>
                <Col md={4}>
                  <FormikInput
                    label="First Name*"
                    id="firstName"
                    name="firstName"
                    placeholder="First Name"
                  />
                </Col>
                <Col md={4}>
                  <FormikInput
                    label="Last Name*"
                    id="lastName"
                    name="lastName"
                    placeholder="Last Name"
                  />
                </Col>
                <Col md={4}>
                  <FormikInput
                    label="Mobile Number*"
                    id="mobile"
                    name="mobile"
                    placeholder="Mobile Number"
                  />
                </Col>
              </Row>

              <Row>
                <Col md={4}>
                  <FormikInput
                    label="Email*"
                    id="email"
                    name="email"
                    type="email"
                    placeholder="Email"
                  />
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label htmlFor="preferredRole">Preferred Job Role*</Label>
                    <Field name="preferredRole" id="preferredRole">
                      {({ field, meta }) => (
                        <>
                          <Input
                            type="select"
                            {...field}
                            invalid={meta.touched && !!meta.error}
                          >
                            <option value="">Select</option>
                            <option>Developer</option>
                            <option>Designer</option>
                            <option>Tester</option>
                          </Input>
                          <FormFeedback>{meta.error}</FormFeedback>
                        </>
                      )}
                    </Field>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label htmlFor="experience">Experience*</Label>
                    <Field name="experience" id="experience">
                      {({ field, meta }) => (
                        <>
                          <Input
                            type="select"
                            {...field}
                            onChange={(e) => {
                              handleChange(e);
                              setExperience(e.target.value);
                              setFieldValue("experience", e.target.value);
                            }}
                            invalid={meta.touched && !!meta.error}
                          >
                            <option>Fresher</option>
                            <option>Experienced</option>
                          </Input>
                          <FormFeedback>{meta.error}</FormFeedback>
                        </>
                      )}
                    </Field>
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col md={4}>
                  <FormGroup>
                    <Label htmlFor="workingStatus">Working Status*</Label>
                    <Field name="workingStatus" id="workingStatus">
                      {({ field, meta }) => (
                        <>
                          <Input
                            type="select"
                            {...field}
                            invalid={meta.touched && !!meta.error}
                          >
                            <option value="">Select</option>
                            <option>Ready to work</option>
                            <option>Working</option>
                            <option>Ready to join</option>
                          </Input>
                          <FormFeedback>{meta.error}</FormFeedback>
                        </>
                      )}
                    </Field>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormikInput
                    label="Notice Period"
                    id="noticePeriod"
                    name="noticePeriod"
                    placeholder="Notice Period"
                  />
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label htmlFor="status">Status*</Label>
                    <Field name="status" id="status">
                      {({ field, meta }) => (
                        <>
                          <Input
                            type="select"
                            {...field}
                            invalid={meta.touched && !!meta.error}
                          >
                            <option value="">Select</option>
                            <option>Working</option>
                            <option>Notice period</option>
                            <option>No job</option>
                          </Input>
                          <FormFeedback>{meta.error}</FormFeedback>
                        </>
                      )}
                    </Field>
                  </FormGroup>
                </Col>
              </Row>

              {experience !== "Fresher" && (
                <Row>
                  <Col md={4}>
                    <FormikInput
                      label="Experience Details*"
                      id="experienceDetails"
                      name="experienceDetails"
                      placeholder="Experience"
                    />
                  </Col>
                  <Col md={4}>
                    <FormikInput
                      label="Current CTC*"
                      id="currentCtc"
                      name="currentCtc"
                      placeholder="Current CTC"
                    />
                  </Col>
                  <Col md={4}>
                    <FormikInput
                      label="Expected CTC*"
                      id="expectedCtc"
                      name="expectedCtc"
                      placeholder="Expected CTC"
                    />
                  </Col>
                </Row>
              )}
              <Row>
                <Col md={4}>
                  <FormGroup>
                    <Label htmlFor="willingToRelocate">
                      Willing to Relocate?
                    </Label>
                    <Field name="willingToRelocate" id="willingToRelocate">
                      {({ field, meta }) => (
                        <>
                          <Input
                            type="select"
                            {...field}
                            invalid={meta.touched && !!meta.error}
                          >
                            <option value="">Select</option>
                            <option>Yes</option>
                            <option>No</option>
                            <option>Maybe</option>
                          </Input>
                          <FormFeedback>{meta.error}</FormFeedback>
                        </>
                      )}
                    </Field>
                  </FormGroup>
                </Col>
              </Row>

              {/* Personal Info */}
              <Row className="heading mt-4 pe-4">
                <p className="sub-head">02 - Personal Information</p>
              </Row>

              <Row>
                <Col md={4}>
                  <FormikInput
                    type="date"
                    label="Date of Birth*"
                    id="dob"
                    name="dob"
                    placeholder="DD-MM-YYYY"
                  />
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label htmlFor="gender">Gender*</Label>
                    <Field name="gender" id="gender">
                      {({ field, meta }) => (
                        <>
                          <Input
                            type="select"
                            {...field}
                            invalid={meta.touched && !!meta.error}
                          >
                            <option value="">Select</option>
                            <option>Male</option>
                            <option>Female</option>
                          </Input>
                          <FormFeedback>{meta.error}</FormFeedback>
                        </>
                      )}
                    </Field>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label htmlFor="maritalStatus">Marital Status</Label>
                    <Field name="maritalStatus" id="maritalStatus">
                      {({ field, meta }) => (
                        <>
                          <Input
                            type="select"
                            {...field}
                            invalid={meta.touched && !!meta.error}
                          >
                            <option value="">Select</option>
                            <option>Married</option>
                            <option>Single</option>
                          </Input>
                          <FormFeedback>{meta.error}</FormFeedback>
                        </>
                      )}
                    </Field>
                  </FormGroup>
                </Col>
              </Row>

              {/* Address */}
              <Row className="heading mt-4 pe-4">
                <p className="sub-head">03 - Residence & Permanent Address</p>
              </Row>

              <Row>
                <Col md={4}>
                  <FormGroup>
                    <Label htmlFor="country">Country*</Label>
                    <Field name="country" id="country">
                      {({ field, meta }) => (
                        <>
                          <Input
                            type="select"
                            {...field}
                            invalid={meta.touched && !!meta.error}
                          >
                            <option value="">Select</option>
                            <option>India</option>
                            <option>USA</option>
                            <option>UK</option>
                          </Input>
                          <FormFeedback>{meta.error}</FormFeedback>
                        </>
                      )}
                    </Field>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label htmlFor="province">Province*</Label>
                    <Field name="province" id="province">
                      {({ field, meta }) => (
                        <>
                          <Input
                            type="select"
                            {...field}
                            invalid={meta.touched && !!meta.error}
                          >
                            <option value="">Select</option>
                            <option>Ontario</option>
                            <option>Quebec</option>
                            <option>Nova Scotia</option>
                          </Input>
                          <FormFeedback>{meta.error}</FormFeedback>
                        </>
                      )}
                    </Field>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormikInput
                    label="Zipcode*"
                    id="zipcode"
                    name="zipcode"
                    placeholder="Zipcode"
                  />
                </Col>
              </Row>

              <Row>
                <Col md={4}>
                  <FormGroup>
                    <Label htmlFor="city">City*</Label>
                    <Field name="city" id="city">
                      {({ field, meta }) => (
                        <>
                          <Input
                            type="select"
                            {...field}
                            invalid={meta.touched && !!meta.error}
                          >
                            <option value="">Select</option>
                            <option>Hyderabad</option>
                            <option>Warangal</option>
                            <option>Siddipet</option>
                          </Input>
                          <FormFeedback>{meta.error}</FormFeedback>
                        </>
                      )}
                    </Field>
                  </FormGroup>
                </Col>
                <Col md={8}>
                  <FormikInput
                    label="Address*"
                    id="address"
                    name="address"
                    placeholder="Address"
                  />
                </Col>
              </Row>

              {/* Social */}
              <Row className="heading mt-4 pe-4">
                <p className="sub-head">04 - Social Profiles</p>
              </Row>

              <Row>
                <Col md={4}>
                  <FormikInput
                    label="LinkedIn*"
                    id="linkedIn"
                    name="linkedIn"
                    placeholder="LinkedIn "
                  />
                </Col>
                <Col md={4}>
                  <FormikInput
                    label="Git Hub"
                    id="github"
                    name="github"
                    placeholder="Github"
                  />
                </Col>
                <Col md={4}>
                  <FormikInput
                    label="Portfolio/ Website URL"
                    id="portfolio"
                    name="portfolio"
                    placeholder="Portfolio/ Website"
                  />
                </Col>
              </Row>

              {/* Buttons */}
              <Row className="d-flex gap-3 justify-content-end mt-4 pe-3">
                <Button
                  type="button"
                  style={{
                    width: "160px",
                    backgroundColor: "white",
                    color: "#475467",
                    borderRadius: "12px",
                    borderColor: "#475467",
                    height: "45px",
                  }}
                >
                  Close
                </Button>
                <Button
                  type="submit"
                  style={{
                    width: "160px",
                    backgroundColor: "#006438",
                    color: "white",
                    borderRadius: "12px",
                    // borderColor: "#3A6AFF",
                    height: "45px",
                  }}
                  // onClick={console.log(validationSchema.firstName)}
                >
                  Submit
                </Button>
              </Row>
            </Form>
          )}
        </Formik>
      </Container>
    </div>
  );
};

export default NewCandidates;
